/**
 * useAlarmDetail — identity-detail fetch for the panel's transition timeline.
 *
 * Identity keyed by (siteId, deviceId, conditionKey) — the canonical identity
 * tuple used across Phase 2 reconciler, Phase 3 API, Phase 4 WS. All three
 * parts must be present for the query to run.
 */

import { useQuery } from '@tanstack/react-query';
import { alarmsApi } from '../services/alarmsApi';

export function useAlarmDetail(siteId: string, deviceId: string, conditionKey: string) {
  return useQuery({
    queryKey: ['alarms', siteId, 'detail', deviceId, conditionKey],
    queryFn: () => alarmsApi.getDetail(siteId, deviceId, conditionKey),
    enabled: !!(siteId && deviceId && conditionKey),
  });
}
